import { render, staticRenderFns } from "./ModalSocials.vue?vue&type=template&id=0bbe2eb4&"
import script from "./ModalSocials.vue?vue&type=script&lang=js&"
export * from "./ModalSocials.vue?vue&type=script&lang=js&"
import style0 from "./ModalSocials.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports